import Service from './service' //网点列表
//售后
export default [
    {
        path: 'afterSales',
        name: 'afterSales',
        meta: {
            title: '售后',
            icon: 'afterSales'
        },
        hidden: false,
        component: () => import("@/views/afterSales/index.vue"),
        children:[
            ...Service,
        ]
    }
]